<table *ngIf='showTable' mat-table [dataSource]="tableData" class="details-screen-table table-scrollbar">
  <ng-container matColumnDef="incassantName">
    <th mat-header-cell *matHeaderCellDef> Naam Incassant </th>
    <td mat-cell *matCellDef="let data"> {{data.creditorName ? data.creditorName : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="incassantId">
    <th mat-header-cell *matHeaderCellDef> Incassant ID </th>
    <td mat-cell *matCellDef="let data"> {{data.creditorId ? data.creditorId : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="machtigingskenmerk">
    <th mat-header-cell *matHeaderCellDef> Machtigingskenmerk </th>
    <td mat-cell *matCellDef="let data"> {{data.mandateReferenceId ? data.mandateReferenceId : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="maxAantalKalJaar">
    <th mat-header-cell *matHeaderCellDef> Max. aantal / kal.jaar </th>
    <td mat-cell *matCellDef="let data"> {{data.maxMandateFrequency ? data.maxMandateFrequency : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="maxBedragKeer">
    <th mat-header-cell *matHeaderCellDef> Max. bedrag / keer </th>
    <td mat-cell *matCellDef="let data"> {{ showMaxBedrag(data) }} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
</table>
